var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8248 12.899L20.2048 18.279C20.3939 18.4682 20.5 18.7248 20.5 18.9924C20.4999 19.2599 20.3935 19.5164 20.2043 19.7055C20.015 19.8946 19.7584 20.0008 19.4909 20.0007C19.2234 20.0006 18.9669 19.8942 18.7778 19.705L13.3978 14.325C11.7895 15.5707 9.76705 16.1569 7.74189 15.9644C5.71674 15.7718 3.841 14.815 2.49625 13.2886C1.1515 11.7622 0.438758 9.78081 0.50302 7.74755C0.567281 5.71428 1.40372 3.78186 2.84217 2.34341C4.28063 0.904951 6.21305 0.0685133 8.24631 0.00425191C10.2796 -0.0600095 12.261 0.652732 13.7874 1.99748C15.3138 3.34223 16.2706 5.21798 16.4631 7.24313C16.6556 9.26828 16.0694 11.2907 14.8238 12.899H14.8248ZM8.49977 14C10.0911 14 11.6172 13.3679 12.7424 12.2426C13.8676 11.1174 14.4998 9.5913 14.4998 8C14.4998 6.4087 13.8676 4.88258 12.7424 3.75736C11.6172 2.63214 10.0911 2 8.49977 2C6.90847 2 5.38235 2.63214 4.25713 3.75736C3.13191 4.88258 2.49977 6.4087 2.49977 8C2.49977 9.5913 3.13191 11.1174 4.25713 12.2426C5.38235 13.3679 6.90847 14 8.49977 14V14Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.86245b3a9d9953a18e5124bae6d6bfc1.svg";
export { ForwardRef as ReactComponent };